import { read_timeline_iso_date } from "../../../utils/timeline/timeline_normalization";
import { read_timeline_value_label } from "../../../utils/timeline/timeline_formatting";

// Keeps historical dates in the same timezone used to assemble person/day cards.
export const read_legacy_activity_date = (value, options = {}) => {
    const isoDate = read_timeline_iso_date(value);

    return isoDate ? new Date(isoDate).toLocaleString("en-GB", {
        timeZone: "Europe/Athens",
        hour12: false,
        ...options
    }) : "";
};

export const legacyActivityDateOptions = { day: "2-digit", month: "short", year: "numeric" };
export const legacyActivityTimeOptions = { hour: "2-digit", minute: "2-digit" };

// Makes list-valued contacts readable without dropping meaningful zero/false values.
export const read_legacy_activity_value = (value) => {
    if (Array.isArray(value)) {
        return value.map(read_legacy_activity_value).join(", ") || "-";
    }

    if (typeof value === "number" || typeof value === "boolean") {
        return `${value}`;
    }

    return read_timeline_value_label(value?.label || value?.number || value?.phone || value);
};
